import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { LIST_NUMBER_OF_CYLINDER_PER_MANIFOLD } from "../../variables/constants";
import {
  getServices,
  postServices,
  putServices,
} from "../../apiServices/apiServices";
import toast from "react-hot-toast";
import LoadingGif from "../../assets/loading_anim.gif";
import {
  Button,
  Tab,
  TabPanel,
  Tabs,
  TabsBody,
  TabsHeader,
} from "@material-tailwind/react";

const tab_data = [
  {
    label: "Manifold & Cylinder Details",
    value: "1",
  },
  {
    label: "Configure Device Parameters",
    value: "2",
  },
];

const simulated_time_type_options = [
  { value: "1", label: "Minutes" },
  { value: "2", label: "Hours" },
  { value: "3", label: "Days" },
];

function ManageParameters() {
  const [fieldData, setFieldData] = useState({
    manifold: null,
    no_of_cylinder: [],
    type_of_cylinder: "",
    ws_status: "",
    burner: null,
    shift_pressure: "",
    prlt: null,
    prht: null,
    mfr: null,
    mfprd: null,
    aco: "",
    al: "",
    mffe: "",
    mfl: "",
    simulated_time: "",
    simulated_time_type: null,
    // bypass_tr: "",
    postrun_empty_tr: "",
    running_empty_tr: "",
    running_loaded_tr: "",
    postrun_loaded_tr: "",
    running_postrun_tr: "",
  });

  const [cylinderTypeDropdownValues, setCylinderTypeDropdownValues] = useState(
    []
  );
  const [loading, setLoading] = useState({ screen: false, btn: false });
  const access_token = localStorage.getItem("gassol-admin-token");
  const location = useLocation().state;
  // const navigate = useNavigate();

  useEffect(() => {
    // if (location) {
    //   setFieldData({
    //     ...fieldData,
    //     manifold: location.manifold
    //       ? { label: location.manifold, value: location.manifold }
    //       : null,
    //     no_of_cylinder: location.no_of_cylinder,
    //     type_of_cylinder: location.type_of_cylinder,
    //     ws_status: location.ws_status,
    //     burner: location.burner
    //       ? { label: location.burner, value: location.burner }
    //       : null,
    //     shift_pressure: location.shift_pressure ?? "",
    //     prlt: location.prlt ?? "",
    //     prht: location.prht ?? "",
    //     mfr: location.mfr ?? "",
    //     mfprd: location.mfprd ?? "",
    //     aco: location.aco ?? "",
    //   });
    // }

    fetchCylinderTypeList();
    fetchControllerDetails();
  }, []);

  const fetchControllerDetails = async () => {
    setLoading(true);

    try {
      const res = await getServices(
        `/api/hardware/data?hardware_id=${location.hardware_id}`
      );
      setLoading(false);

      // console.log(res);

      if (res.responseCode === 200) {
        let response = res.responseData?.[0];

        setFieldData({
          ...fieldData,
          manifold: response?.manifoldInfo[0]?.no_of_manifold
            ? {
                label: response?.manifoldInfo[0]?.no_of_manifold,
                value: response?.manifoldInfo[0]?.no_of_manifold,
              }
            : null,
          no_of_cylinder: response?.manifoldInfo[0]?.no_of_cylinder || [],
          type_of_cylinder: response?.type_of_cylinder || "",
          ws_status: response?.ws_status,
          burner: response?.burner
            ? {
                label: response?.burner?.toString(),
                value: response?.burner?.toString(),
              }
            : null,
          shift_pressure: response?.shift_pressure ?? "",
          prlt: response?.prlt ?? "",
          prht: response?.prht ?? "",
          mfr: response.mfr ?? "",
          mfprd: response?.mfprd ?? "",
          aco: response?.aco ?? "",
          al: response?.al ?? "",
          simulated_time: response?.simulated_time
            ? response?.simulated_type == 1
              ? response?.simulated_time
              : response?.simulated_type == 2
              ? response?.simulated_time / 60
              : response?.simulated_type == 3
              ? response?.simulated_time / 1440
              : response?.simulated_time
            : null,
          simulated_time_type: response?.simulated_type
            ? simulated_time_type_options.find(
                (item) => item.value == response?.simulated_type?.toString()
              )
            : null,
          // bypass_tr: response?.bypass_tr ?? "",
          postrun_empty_tr: response?.postrun_empty_tr ?? "",
          running_empty_tr: response?.running_empty_tr ?? "",
          running_loaded_tr: response?.running_loaded_tr ?? "",
          postrun_loaded_tr: response?.postrun_loaded_tr ?? "",
          running_postrun_tr: response?.running_postrun_tr ?? "",
        });
      } else {
        setFieldData({
          ...fieldData,
          manifold: null,
          no_of_cylinder: [],
          type_of_cylinder: null,
          ws_status: "",
          burner: null,
          shift_pressure: "",
          prlt: null,
          prht: null,
          mfr: null,
          mfprd: null,
          aco: "",
          al: "",
          simulated_time: "",
          simulated_time_type: null,
          // bypass_tr: "",
          postrun_empty_tr: "",
          running_empty_tr: "",
          running_loaded_tr: "",
          postrun_loaded_tr: "",
          running_postrun_tr: "",
        });
        toast.error(res.responseMessage);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const fetchCylinderTypeList = async () => {
    setLoading({ ...loading, screen: true });
    try {
      const res = await getServices(`/api/list/cylindertype`, access_token);
      setLoading({ ...loading, screen: false });
      if (res.responseCode === 200) {
        setCylinderTypeDropdownValues(res.responseData);
      } else {
        setCylinderTypeDropdownValues([]);
      }
    } catch (error) {
      setLoading({ ...loading, screen: false });
      toast.error(error);
    }
  };

  const handleManifoldChange = (selectedManifold) => {
    setFieldData({
      ...fieldData,
      manifold: selectedManifold,
      cylinders: Array(selectedManifold?.value).fill(null), // Reset cylinder selections
    });
  };

  const handleSimulatedTimeTypeChange = (selectedSimulatedTimeType) => {
    setFieldData({
      ...fieldData,
      simulated_time_type: selectedSimulatedTimeType,
    });
  };

  const handleCylinderSelectChange = (value, index) => {
    const updatedCylinders = [...fieldData.no_of_cylinder];
    updatedCylinders[index] = value?.value || null;
    setFieldData({
      ...fieldData,
      no_of_cylinder: updatedCylinders,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    const urlencoded = new URLSearchParams();

    urlencoded.append("hardware_id", location.hardware_id);
    urlencoded.append(
      "type_of_cylinder",
      fieldData.type_of_cylinder?.label ?? fieldData.type_of_cylinder
    );
    urlencoded.append("manifold", fieldData.manifold?.label);
    urlencoded.append("burner", fieldData.burner?.label);
    urlencoded.append("ws_status", fieldData.ws_status);
    // urlencoded.append("shift_pressure", fieldData.shift_pressure);
    for (let i = 0; i < fieldData.no_of_cylinder.length; i++) {
      urlencoded.append("no_of_cylinder", fieldData.no_of_cylinder[i]);
    }

    if (fieldData.simulated_time_type?.value == 1) {
      urlencoded.append("simulated_time", fieldData.simulated_time);
    } else if (fieldData.simulated_time_type?.value == 2) {
      urlencoded.append("simulated_time", fieldData.simulated_time * 60);
    } else if (fieldData.simulated_time_type?.value == 3) {
      urlencoded.append("simulated_time", fieldData.simulated_time * 1440);
    }
    urlencoded.append("simulated_type", fieldData?.simulated_time_type?.value);
    // urlencoded.append("bypass_tr", fieldData?.bypass_tr);
    urlencoded.append("postrun_empty_tr", fieldData?.postrun_empty_tr);
    urlencoded.append("running_empty_tr", fieldData?.running_empty_tr);
    urlencoded.append("running_loaded_tr", fieldData?.running_loaded_tr);
    urlencoded.append("postrun_loaded_tr", fieldData?.postrun_loaded_tr);
    urlencoded.append("running_postrun_tr", fieldData?.running_postrun_tr);

    try {
      const res = await postServices(
        `/api/hardware/setparam`,
        urlencoded,
        access_token
      );
      setLoading({ ...loading, btn: false });
      if (res.responseCode === 200) {
        // navigate(-1);
        fetchControllerDetails();
        toast.success("Manifold & cylinder details are submitted.");
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
      setLoading({ ...loading, btn: false });
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    const urlencoded = new URLSearchParams();

    urlencoded.append(
      "type_of_cylinder",
      fieldData.type_of_cylinder?.label ?? fieldData.type_of_cylinder
    );
    urlencoded.append("manifold", fieldData.manifold?.label);
    urlencoded.append("burner", fieldData.burner?.label);
    urlencoded.append("ws_status", fieldData.ws_status);
    // urlencoded.append("shift_pressure", fieldData.shift_pressure);
    for (let i = 0; i < fieldData.no_of_cylinder.length; i++) {
      urlencoded.append("no_of_cylinder", fieldData.no_of_cylinder[i]);
    }

    if (fieldData.simulated_time_type?.value == 1) {
      urlencoded.append("simulated_time", fieldData.simulated_time);
    } else if (fieldData.simulated_time_type?.value == 2) {
      urlencoded.append("simulated_time", fieldData.simulated_time * 60);
    } else if (fieldData.simulated_time_type?.value == 3) {
      urlencoded.append("simulated_time", fieldData.simulated_time * 1440);
    }
    urlencoded.append("simulated_type", fieldData?.simulated_time_type?.value);
    // urlencoded.append("bypass_tr", fieldData?.bypass_tr);
    urlencoded.append("postrun_empty_tr", fieldData?.postrun_empty_tr);
    urlencoded.append("running_empty_tr", fieldData?.running_empty_tr);
    urlencoded.append("running_loaded_tr", fieldData?.running_loaded_tr);
    urlencoded.append("postrun_loaded_tr", fieldData?.postrun_loaded_tr);
    urlencoded.append("running_postrun_tr", fieldData?.running_postrun_tr);

    try {
      const res = await putServices(
        `/api/hardware/activate/update?hardware_id=${location.hardware_id}`,
        urlencoded,
        access_token
      );

      setLoading({ ...loading, btn: false });
      if (res.responseCode === 200) {
        // navigate(-1);
        fetchControllerDetails();
        toast.success("Manifold & cylinder details are updated.");
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      setLoading({ ...loading, btn: false });
      toast.error(error);
    }
  };

  const handleEmptyingSubmit = async (e, field) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    try {
      const res = await postServices(
        `/api/hardware/postrun/setconfig`,
        field,
        // {
        //   hardware_id: location.hardware_id,
        //   prlt: fieldData.prlt,
        //   prht: fieldData.prht,
        //   mfr: fieldData.mfr,
        //   mfprd: fieldData.mfprd,
        //   shift_pressure: fieldData.shift_pressure,
        //   aco: fieldData.aco,
        // },
        access_token
      );
      setLoading({ ...loading, btn: false });
      if (res.responseCode === 200) {
        // navigate(-1);
        fetchControllerDetails();
        toast.success("Device parameters are submitted.");
      } else if (res.responseCode === 211) {
        toast.error(
          "Device is currently offline. To save the device configuration please keep the device online!"
        );
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      setLoading({ ...loading, btn: false });
      toast.error(error);
    }
  };

  return (
    <>
      <div className="py-4 md:py-8 max-w-[1400px] mx-auto px-3">
        {!loading.screen ? (
          <>
            <div className="flex gap-2 md:justify-between items-start md:items-center flex-col md:flex-row">
              <div className="flex gap-3 sm:gap-6">
                <Link
                  to={-1}
                  className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
                >
                  <IoChevronBackOutline />
                  <p>{location.isUpdate ? "Update" : "Set"} Parameters</p>
                </Link>
              </div>
            </div>

            <Tabs value="1" className="mt-5">
              <TabsHeader
                className="bg-transparent"
                indicatorProps={{
                  className: "bg-gray-900/10 shadow-none !text-gray-900",
                }}
              >
                {tab_data.map(({ label, value }) => (
                  <Tab
                    key={value}
                    value={value}
                    className="font-poppins font-semibold py-3"
                    disabled={loading.btn}
                  >
                    {label}
                  </Tab>
                ))}
              </TabsHeader>

              <TabsBody>
                <TabPanel value={"1"} className="font-poppins">
                  <form
                    className="mt-5"
                    onSubmit={location.isUpdate ? handleUpdate : handleSubmit}
                  >
                    <p className="text-[#BDBDBD]">
                      Manifold & Cylinder Details *
                    </p>

                    <div className="grid md:grid-cols-2 gap-4 md:gap-7 mt-4">
                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Select a Cylinder Type *
                        </label>
                        {/* <ReactSelect
                          value={
                            fieldData.type_of_cylinder
                              ? cylinderTypeDropdownValues?.find(
                                  (item) =>
                                    item.cylinder_type ==
                                    fieldData.type_of_cylinder
                                )
                              : null
                          }
                          onChange={(e) =>
                            setFieldData({
                              ...fieldData,
                              type_of_cylinder: e,
                            })
                          }
                          options={cylinderTypeDropdownValues?.map((item) => {
                            return {
                              label: item.cylinder_type?.toFixed(2),
                              value: item._id,
                            };
                          })}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: "#f5f7f9",
                              border: "none",
                              padding: "20px 24px",
                              borderRadius: "16px",
                            }),
                          }}
                          placeholder="Select a Cylinder Type"
                          isClearable
                          required={!location.isUpdate}
                        /> */}

                        <ReactSelect
                          value={
                            fieldData.type_of_cylinder
                              ? {
                                  label: cylinderTypeDropdownValues
                                    ?.find(
                                      (item) =>
                                        // item._id === fieldData.type_of_cylinder
                                        item.cylinder_type ===
                                        Number(fieldData.type_of_cylinder)
                                    )
                                    ?.cylinder_type?.toFixed(2),
                                  value: fieldData.type_of_cylinder,
                                }
                              : null
                          }
                          onChange={(e) =>
                            setFieldData({
                              ...fieldData,
                              type_of_cylinder: e ? e.label : null,
                            })
                          }
                          options={cylinderTypeDropdownValues?.map((item) => ({
                            label: item.cylinder_type?.toFixed(2),
                            value: item._id,
                          }))}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: "#f5f7f9",
                              border: "none",
                              padding: "20px 24px",
                              borderRadius: "16px",
                            }),
                          }}
                          placeholder="Select a Cylinder Type"
                          required={!location.isUpdate}
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Is weighing scale installed? *
                        </label>
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            sx={{
                              display: "flex !important",
                              flexDirection: "row !important",
                            }}
                            value={fieldData.ws_status}
                            onChange={(e) =>
                              setFieldData({
                                ...fieldData,
                                ws_status: e.target.value,
                              })
                            }
                          >
                            <FormControlLabel
                              value="1"
                              control={<Radio required />}
                              label="Yes"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                            <FormControlLabel
                              value="0"
                              control={<Radio required />}
                              label="No"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>

                      {/* <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Enter the Shift Pressure *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                          type="number"
                          placeholder="Enter the Shift Pressure"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={fieldData.shift_pressure}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                shift_pressure: value,
                              });
                            }
                          }}
                          min={0}
                          max={16}
                          step={"0.001"}
                          required
                        />
                      </div> */}

                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Select a number of burners *
                        </label>
                        <ReactSelect
                          value={fieldData.burner}
                          onChange={(e) =>
                            setFieldData({ ...fieldData, burner: e })
                          }
                          options={[1, 2, 3, 4]?.map((item) => {
                            return {
                              label: item,
                              value: item,
                            };
                          })}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: "#f5f7f9",
                              border: "none",
                              padding: "20px 24px",
                              borderRadius: "16px",
                            }),
                          }}
                          placeholder="Select a number of burners"
                          menuPlacement="top"
                          // isClearable
                          required
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Select a number of manifold *
                        </label>
                        <ReactSelect
                          value={fieldData.manifold}
                          onChange={handleManifoldChange}
                          options={[1, 2]?.map((item) => {
                            return {
                              label: item,
                              value: item,
                            };
                          })}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: "#f5f7f9",
                              border: "none",
                              padding: "20px 24px",
                              borderRadius: "16px",
                            }),
                          }}
                          placeholder="Select a number of manifold"
                          menuPlacement="top"
                          // isClearable
                          required
                        />
                      </div>

                      {fieldData.manifold &&
                        Array.from(
                          { length: Number(fieldData.manifold?.label) },
                          (_, index) => index + 1
                        ).map((item, i) => (
                          <div className="flex flex-col gap-2" key={i}>
                            <label className="text-black font-semibold">
                              Select the number of cylinders per manifold{" "}
                              {i + 1}. *
                            </label>
                            <ReactSelect
                              value={
                                fieldData?.no_of_cylinder
                                  ? fieldData?.no_of_cylinder[i]
                                    ? {
                                        label: fieldData?.no_of_cylinder[i],
                                        value: fieldData?.no_of_cylinder[i],
                                      }
                                    : null
                                  : null
                              }
                              onChange={(e) => handleCylinderSelectChange(e, i)}
                              options={LIST_NUMBER_OF_CYLINDER_PER_MANIFOLD?.map(
                                (item) => {
                                  return {
                                    label: item,
                                    value: item,
                                  };
                                }
                              )}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: "#f5f7f9",
                                  border: "none",
                                  padding: "20px 24px",
                                  borderRadius: "16px",
                                }),
                              }}
                              placeholder={`Select the number of cylinders per manifold ${
                                i + 1
                              }`}
                              menuPlacement="top"
                              // isClearable
                              required
                            />
                          </div>
                        ))}

                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Simulated Time for Bypassing *
                        </label>
                        <div className="flex flex-row gap-0 w-full">
                          <input
                            className="w-full bg-[#f5f7f9] px-8 py-6 border border-blue-600 text-lg outline-none text-gray-800 custom-number-input"
                            style={{ borderRadius: "16px 0 0 16px" }}
                            type="number"
                            placeholder="Enter the Simulated Time"
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => e.target.blur()}
                            value={fieldData.simulated_time}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (
                                value === "" ||
                                (Number(value) >= 0 &&
                                  Number(value) <= 16 &&
                                  /^\d*\.?\d*$/.test(value))
                              ) {
                                setFieldData({
                                  ...fieldData,
                                  simulated_time: value,
                                });
                              }
                            }}
                            min={0}
                            // max={16}
                            // step={"0.001"}
                            required
                          />

                          <ReactSelect
                            value={fieldData.simulated_time_type}
                            onChange={handleSimulatedTimeTypeChange}
                            options={simulated_time_type_options?.map(
                              (item) => {
                                return {
                                  label: item.label,
                                  value: item.value,
                                };
                              }
                            )}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: "#f5f7f9",
                                border: "1px solid #007bff",
                                padding: "20px 24px",
                                borderRadius: "0 16px 16px 0",
                              }),
                            }}
                            className="w-full"
                            placeholder="Select a type"
                            menuPlacement="top"
                            // isClearable
                            required
                          />
                        </div>
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Bypass threshold (Run-Empty) *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg outline-none text-gray-800 custom-number-input"
                          style={{ borderRadius: "16px 0 0 16px" }}
                          type="number"
                          placeholder="Enter the Bypass threshold (Run-Empty)"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={fieldData.running_empty_tr}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                running_empty_tr: value,
                              });
                            }
                          }}
                          min={0}
                          // max={16}
                          step={"0.001"}
                          required
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Bypass threshold (Run-Loaded) *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg outline-none text-gray-800 custom-number-input"
                          style={{ borderRadius: "16px 0 0 16px" }}
                          type="number"
                          placeholder="Enter the Bypass threshold (Run-Loaded)"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={fieldData.running_loaded_tr}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                running_loaded_tr: value,
                              });
                            }
                          }}
                          min={0}
                          // max={16}
                          step={"0.001"}
                          required
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Bypass threshold (Emptying-Empty) *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg outline-none text-gray-800 custom-number-input"
                          style={{ borderRadius: "16px 0 0 16px" }}
                          type="number"
                          placeholder="Enter the Bypass threshold (Emptying-Empty)"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={fieldData.postrun_empty_tr}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                postrun_empty_tr: value,
                              });
                            }
                          }}
                          min={0}
                          // max={16}
                          step={"0.001"}
                          required
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Bypass threshold (Emptying-Loaded) *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg outline-none text-gray-800 custom-number-input"
                          style={{ borderRadius: "16px 0 0 16px" }}
                          type="number"
                          placeholder="Enter the Bypass threshold (Emptying-Loaded)"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={fieldData.postrun_loaded_tr}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                postrun_loaded_tr: value,
                              });
                            }
                          }}
                          min={0}
                          // max={16}
                          step={"0.001"}
                          required
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <label className="text-black font-semibold">
                          Bypass threshold (Run-Emptying) *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg outline-none text-gray-800 custom-number-input"
                          style={{ borderRadius: "16px 0 0 16px" }}
                          type="number"
                          placeholder="Enter the Bypass threshold (Run-Emptying)"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={fieldData.running_postrun_tr}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                running_postrun_tr: value,
                              });
                            }
                          }}
                          min={0}
                          // max={16}
                          step={"0.001"}
                          required
                        />
                      </div>
                    </div>
                    <div className="my-3 flex justify-end items-center">
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn
                          ? location.isUpdate
                            ? "Update"
                            : "Save"
                          : "Loading..."}
                      </Button>
                    </div>
                  </form>
                </TabPanel>

                <TabPanel value={"2"} className="font-poppins">
                  <p className="text-[#BDBDBD] mt-5">Device Parameters *</p>

                  <div className="grid md:grid-cols-2 gap-4 md:gap-7">
                    <form
                      className="flex flex-col sm:flex-row items-end gap-3"
                      onSubmit={(e) =>
                        handleEmptyingSubmit(e, {
                          hardware_id: location.hardware_id,
                          shift_pressure: fieldData.shift_pressure,
                        })
                      }
                    >
                      <div className="flex flex-col gap-2 mt-1 w-full">
                        <label className="text-black font-semibold">
                          Enter the Shift Pressure *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                          type="number"
                          placeholder="Enter the Shift Pressure"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={fieldData.shift_pressure}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                shift_pressure: value,
                              });
                            }
                          }}
                          min={0}
                          max={16}
                          step={"0.001"}
                          required
                        />
                      </div>
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn ? "Save" : "Loading..."}
                      </Button>
                    </form>

                    <form
                      className="flex flex-col sm:flex-row items-end gap-3"
                      onSubmit={(e) =>
                        handleEmptyingSubmit(e, {
                          hardware_id: location.hardware_id,
                          aco: fieldData.aco,
                        })
                      }
                    >
                      <div className="flex flex-col gap-2 mt-1 w-full">
                        <label className="text-black font-semibold">
                          Auto changeover enable/disable *
                        </label>
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            sx={{
                              display: "flex !important",
                              flexDirection: "row !important",
                            }}
                            value={fieldData.aco}
                            onChange={(e) =>
                              setFieldData({
                                ...fieldData,
                                aco: e.target.value,
                              })
                            }
                          >
                            <FormControlLabel
                              value="1"
                              control={<Radio required />}
                              label="Enable"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                            <FormControlLabel
                              value="0"
                              control={<Radio required />}
                              label="Disable"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                          </RadioGroup>
                        </FormControl>
                        {/* <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                          type="number"
                          placeholder="Enter the Shift Pressure"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={fieldData.shift_pressure}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                shift_pressure: value,
                              });
                            }
                          }}
                          min={0}
                          max={16}
                          step={"0.001"}
                          required
                        /> */}
                      </div>
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn ? "Save" : "Loading..."}
                      </Button>
                    </form>
                  </div>

                  <p className="text-[#BDBDBD] mt-4">
                    Emptying Report Details *
                  </p>

                  <div className="grid md:grid-cols-2 gap-4 md:gap-7 mt-1">
                    <form
                      className="flex flex-col sm:flex-row items-end gap-3"
                      onSubmit={(e) =>
                        handleEmptyingSubmit(e, {
                          hardware_id: location.hardware_id,
                          prlt: fieldData.prlt,
                        })
                      }
                    >
                      <div className="flex flex-col gap-2 w-full">
                        <label className="text-black font-semibold">
                          Enter the Low Pressure *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                          type="number"
                          placeholder="Enter the Low Pressure"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={Number(fieldData.prlt)}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0.2 &&
                                Number(value) <= 3.7 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                prlt: value,
                              });
                            }
                          }}
                          min={0.2}
                          max={3.7}
                          step={"0.001"}
                          required
                        />
                      </div>
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn ? "Save" : "Loading..."}
                      </Button>
                    </form>

                    <form
                      className="flex flex-col sm:flex-row items-end gap-3"
                      onSubmit={(e) =>
                        handleEmptyingSubmit(e, {
                          hardware_id: location.hardware_id,
                          prht: fieldData.prht,
                        })
                      }
                    >
                      <div className="flex flex-col gap-2 w-full">
                        <label className="text-black font-semibold">
                          Enter the High Pressure *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                          type="number"
                          placeholder="Enter the High Pressure"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={Number(fieldData.prht)}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0.2 &&
                                Number(value) <= 3.7 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                prht: value,
                              });
                            }
                          }}
                          min={0.2}
                          max={3.7}
                          step={"0.001"}
                          required
                        />
                      </div>
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn ? "Save" : "Loading..."}
                      </Button>
                    </form>

                    <form
                      className="flex flex-col sm:flex-row items-end gap-3"
                      onSubmit={(e) =>
                        handleEmptyingSubmit(e, {
                          hardware_id: location.hardware_id,
                          mfr: fieldData.mfr,
                        })
                      }
                    >
                      <div className="flex flex-col gap-2 w-full">
                        <label className="text-black font-semibold">
                          Enter the number of cycles in emptying process *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                          type="number"
                          placeholder="Enter the number of cycles in emptying process"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={Number(fieldData.mfr)}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                // Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                mfr: value,
                              });
                            }
                          }}
                          min={0}
                          // max={16}
                          step={"1"}
                          required
                        />
                      </div>
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn ? "Save" : "Loading..."}
                      </Button>
                    </form>

                    <form
                      className="flex flex-col sm:flex-row items-end gap-3"
                      onSubmit={(e) =>
                        handleEmptyingSubmit(e, {
                          hardware_id: location.hardware_id,
                          mfprd: fieldData.mfprd,
                        })
                      }
                    >
                      <div className="flex flex-col gap-2 w-full">
                        <label className="text-black font-semibold">
                          Enter the Delay Time to Emptying Process (mins) *
                        </label>
                        <input
                          className="w-full bg-[#f5f7f9] px-8 py-6 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                          type="number"
                          placeholder="Enter the Delay Time to Emptying Process (mins)"
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "E" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          value={Number(fieldData.mfprd)}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 &&
                                // Number(value) <= 16 &&
                                /^\d*\.?\d*$/.test(value))
                            ) {
                              setFieldData({
                                ...fieldData,
                                mfprd: value,
                              });
                            }
                          }}
                          min={0}
                          // max={16}
                          step={"1"}
                          required
                        />
                      </div>
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn ? "Save" : "Loading..."}
                      </Button>
                    </form>

                    <form
                      className="flex flex-col sm:flex-row items-end gap-3"
                      onSubmit={(e) =>
                        handleEmptyingSubmit(e, {
                          hardware_id: location.hardware_id,
                          al: fieldData.al,
                        })
                      }
                    >
                      <div className="flex flex-col gap-2 w-full">
                        <label className="text-black font-semibold">
                          Autoload enable/disable*
                        </label>
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            sx={{
                              display: "flex !important",
                              flexDirection: "row !important",
                            }}
                            value={fieldData.al}
                            onChange={(e) =>
                              setFieldData({
                                ...fieldData,
                                al: e.target.value,
                              })
                            }
                          >
                            <FormControlLabel
                              value="1"
                              control={<Radio required />}
                              label="Enable"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                            <FormControlLabel
                              value="0"
                              control={<Radio required />}
                              label="Disable"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn ? "Save" : "Loading..."}
                      </Button>
                    </form>

                    <form
                      className="flex flex-col sm:flex-row items-end gap-3"
                      onSubmit={(e) =>
                        handleEmptyingSubmit(e, {
                          hardware_id: location.hardware_id,
                          mffe: fieldData.mffe,
                        })
                      }
                    >
                      <div className="flex flex-col gap-2 w-full">
                        <label className="text-black font-semibold">
                          Reset Manifold*
                        </label>
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            sx={{
                              display: "flex !important",
                              flexDirection: "row !important",
                            }}
                            value={fieldData.mffe}
                            onChange={(e) =>
                              setFieldData({
                                ...fieldData,
                                mffe: e.target.value,
                              })
                            }
                          >
                            <FormControlLabel
                              value="1"
                              control={<Radio required />}
                              label="MF1"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                            <FormControlLabel
                              value="2"
                              control={<Radio required />}
                              label="MF2"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn ? "Save" : "Loading..."}
                      </Button>
                    </form>

                    <form
                      className="flex flex-col sm:flex-row items-end gap-3"
                      onSubmit={(e) =>
                        handleEmptyingSubmit(e, {
                          hardware_id: location.hardware_id,
                          mfl: fieldData.mfl,
                        })
                      }
                    >
                      <div className="flex flex-col gap-2 w-full">
                        <label className="text-black font-semibold">
                          Load Manifold *
                        </label>
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            sx={{
                              display: "flex !important",
                              flexDirection: "row !important",
                            }}
                            value={fieldData.mfl}
                            onChange={(e) =>
                              setFieldData({
                                ...fieldData,
                                mfl: e.target.value,
                              })
                            }
                          >
                            <FormControlLabel
                              value="1"
                              control={<Radio required />}
                              label="MF1"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                            <FormControlLabel
                              value="2"
                              control={<Radio required />}
                              label="MF2"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontFamily: "Poppins",
                                },
                              }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <Button
                        type="submit"
                        className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                        disabled={loading.btn}
                      >
                        {!loading.btn ? "Save" : "Loading..."}
                      </Button>
                    </form>
                  </div>

                  {/* <div className="my-3 flex justify-end items-center">
                    <Button
                      type="submit"
                      className="font-poppins font-medium tracking-wider bg-[#03438D] disabled:cursor-not-allowed disabled:bg-slate-500"
                      disabled={loading.btn}
                    >
                      {!loading.btn ? "Save" : "Loading..."}
                    </Button>
                  </div> */}
                  {/* </form> */}
                </TabPanel>
              </TabsBody>
            </Tabs>
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

export default ManageParameters;
